import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { AccessGuard } from "./components/AccessGuard";
import { Layout } from "./components/Layout";
import { Login } from "./pages/Login";
import { MapPage } from "./pages/Map";
import { MethodologyPage } from "./pages/Methodology";
import { FacilitiesPage } from "./pages/Facilities";
import { FacilityDetailPage } from "./pages/FacilityDetail";
import { DashboardPage } from "./pages/Dashboard";
import { GroupsPage } from "./pages/Groups";
import { InterventionsPage } from "./pages/Interventions";
import { PresetsPage } from "./pages/Presets";
import { UsersPage } from "./pages/admin/Users";
import { DataQualityPage } from "./pages/admin/DataQuality";
import { UptimePage } from "./pages/admin/Uptime";
import { AuditLogPage } from "./pages/admin/AuditLog";
import { SyncPage } from "./pages/admin/Sync";
import { SettingsPage } from "./pages/admin/Settings";

const ADMIN_ROLES = ["admin", "super_admin"];

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route element={<AccessGuard><Layout /></AccessGuard>}>
            <Route index element={<Navigate to="/map" replace />} />
            <Route path="/map" element={<MapPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/facilities" element={<FacilitiesPage />} />
            <Route path="/facilities/:edrpou" element={<FacilityDetailPage />} />
            <Route path="/methodology" element={<MethodologyPage />} />
            <Route path="/interventions" element={<InterventionsPage />} />
            <Route path="/groups" element={<GroupsPage />} />
            <Route path="/presets" element={<PresetsPage />} />

            <Route path="/admin/sync" element={
              <AccessGuard roles={ADMIN_ROLES}><SyncPage /></AccessGuard>
            } />
            <Route path="/admin/uptime" element={
              <AccessGuard roles={ADMIN_ROLES}><UptimePage /></AccessGuard>
            } />
            <Route path="/admin/data-quality" element={
              <AccessGuard roles={ADMIN_ROLES}><DataQualityPage /></AccessGuard>
            } />
            <Route path="/admin/settings" element={
              <AccessGuard roles={ADMIN_ROLES}><SettingsPage /></AccessGuard>
            } />
            <Route path="/admin/users" element={
              <AccessGuard roles={ADMIN_ROLES}><UsersPage /></AccessGuard>
            } />
            <Route path="/admin/audit-log" element={
              <AccessGuard roles={ADMIN_ROLES}><AuditLogPage /></AccessGuard>
            } />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

function NotFound() {
  return (
    <div style={{ padding: 60, textAlign: "center" }}>
      <h1 style={{ color: "#1a365d" }}>404</h1>
      <p>Сторінку не знайдено.</p>
      <a href="/map" style={{ color: "#2c5282" }}>На головну →</a>
    </div>
  );
}
